// removed by extract-text-webpack-plugin
module.exports = {"ctaContainer":"Gbde68f"};